import React, { useEffect, useState } from 'react';
import { Trophy, Medal } from 'lucide-react';
import { toast } from 'sonner';
import { bbFetch, Title, Panel, fieldCls } from './bbShared';

const MOIS = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];
const moisLabel = (m) => { const [y, mo] = m.split('-'); return `${MOIS[Number(mo) - 1]} ${y}`; };
const PODIUM = ['#D4A017', '#9CA3AF', '#B87333'];

const Ranking = ({ title, rows, field, unit, testId }) => {
  const max = Math.max(1, ...rows.map(r => r[field]));
  return (
    <div className="rounded-2xl border border-[#E4E1DA] bg-white p-4" data-testid={testId}>
      <p className="mb-3 flex items-center gap-2 text-sm font-bold uppercase tracking-[0.12em] text-slate-600"><Trophy className="h-4 w-4 text-[#F26A1B]" />{title}</p>
      {rows.length === 0 && <p className="text-sm text-slate-500">Aucun commercial.</p>}
      <ol className="space-y-2">
        {rows.map(r => (
          <li key={r.commercial_id} className={`flex items-center gap-3 rounded-xl px-2.5 py-2 ${r.is_me ? 'bg-[#FCEBDD] ring-1 ring-[#F26A1B]/40' : ''}`} data-testid={`${testId}-row-${r.commercial_id}`}>
            <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-sm font-bold text-white" style={{ background: r[field] > 0 && r.rang <= 3 ? PODIUM[r.rang - 1] : '#CBD5E1' }}>
              {r[field] > 0 && r.rang <= 3 ? <Medal className="h-4 w-4" /> : r.rang}
            </span>
            <div className="min-w-0 flex-1">
              <div className="flex items-baseline justify-between gap-2">
                <p className="truncate text-sm font-semibold">{r.rang}. {r.name}{r.is_me ? ' (moi)' : ''}</p>
                <p className="shrink-0 text-lg font-bold" style={{ fontFamily: 'var(--font-display)' }}>{r[field]} <span className="text-xs font-normal text-slate-500">{unit}</span></p>
              </div>
              <div className="mt-1 h-1.5 rounded-full bg-[#EEECE8]"><div className="h-1.5 rounded-full bg-[#F26A1B] transition-[width] duration-500" style={{ width: `${(r[field] / max) * 100}%` }} /></div>
            </div>
          </li>
        ))}
      </ol>
    </div>
  );
};

export const Classement = ({ token }) => {
  const [mois, setMois] = useState('');
  const [data, setData] = useState(null);
  useEffect(() => {
    bbFetch(token, `/bb/declarations/classement${mois ? `?mois=${mois}` : ''}`).then(setData).catch(e => toast.error(e.message));
  }, [token, mois]);
  if (!data) return null;
  return (
    <Panel testId="bb-classement">
      <div className="mb-4 flex flex-wrap items-end justify-between gap-3">
        <div>
          <Title className="text-2xl">Classement de l'équipe · {moisLabel(data.mois)}</Title>
          <p className="text-xs text-slate-500 mt-0.5">D'après les déclarations hebdo des {data.semaines.length} semaine{data.semaines.length > 1 ? 's' : ''} du mois · objectif RDV du mois : {data.objectif_rdv_mois}</p>
        </div>
        <select className={`${fieldCls} !w-auto min-w-[180px]`} value={data.mois} onChange={e => setMois(e.target.value)} data-testid="bb-classement-mois">
          {data.mois_disponibles.map(m => <option key={m} value={m}>{moisLabel(m)}</option>)}
        </select>
      </div>
      <div className="grid gap-4 md:grid-cols-2">
        <Ranking title="RDV réalisés" rows={data.rdv} field="nb_rdv" unit="RDV" testId="bb-classement-rdv" />
        <Ranking title="Visites prospects" rows={data.visites_prospects} field="nb_visites_prospects" unit="visites" testId="bb-classement-visites" />
      </div>
    </Panel>
  );
};
